document.addEventListener("DOMContentLoaded", () => {
    // console.log("before most popular click");

  if (document.querySelector("skio-plan-picker")) {

    document.body.classList.add("__cwc-initialising");

    let host = document.querySelector("skio-plan-picker");
    let shadowRoot = host?.shadowRoot;

    const style = document.createElement("style");
    style.textContent = `.skio-group-container { display: none !important; }`;
    shadowRoot.appendChild(style);

    let otpButton = shadowRoot.querySelector(".skio-group-container");
    let subButton = shadowRoot.querySelector(".skio-group-container.skio-group-container--subscribe");

    if (!subButton) {
      document.body.classList.add("__no-sub-and-save");
    }

    document.body.addEventListener("click", (e) => {

      if (e.target.closest(".cwc-oz44__subscription__one-time")) {
        otpButton.click();
        removeSelected();
        e.target.closest(".cwc-oz44__subscription__btn")
          .querySelector(".cwc-oz44__subscription__radio")
          .classList.add("__selected");
      }

      if (e.target.closest(".cwc-oz44__subscription__sub-save")) {
        subButton = shadowRoot.querySelector(".skio-group-container.skio-group-container--subscribe");
        subButton.click();
        removeSelected();
        e.target.closest(".cwc-oz44__subscription__btn")
          .querySelector(".cwc-oz44__subscription__radio")
          .classList.add("__selected");
      }

      if (e.target.closest(".cwc-oz44__variant-selector-btn")) {
        document.querySelectorAll(".cwc-oz44__variant-selector-btn.__selected-btn").forEach(btn => {
          btn.classList.remove("__selected-btn");
        });

        let tBtn = e.target.closest(".cwc-oz44__variant-selector-btn");
        tBtn?.classList.add("__selected-btn");

        let variantID = tBtn.getAttribute("data-variant-id");
        const variantSelect = document.querySelector(".main-product__variant-select");

        if (variantSelect) {
          variantSelect.value = variantID;
          variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // subButton = shadowRoot.querySelector(".skio-group-container.skio-group-container--subscribe");
      }
    });

    document.body.classList.add("__show-custom-sub-option");

    document.querySelector(".cwc-oz44__variant-selector-btn.__most-popular")?.click();
  }else{
    document.body.addEventListener("click", (e) => {

      if (e.target.closest(".cwc-oz44__variant-selector-btn")) {
        document.querySelectorAll(".cwc-oz44__variant-selector-btn.__selected-btn").forEach(btn => {
          btn.classList.remove("__selected-btn");
        });

        let tBtn = e.target.closest(".cwc-oz44__variant-selector-btn");
        tBtn?.classList.add("__selected-btn");

        let newPrice = tBtn?.querySelector(".cwc-oz44__variant-selector-btn__price").textContent;

        const productPriceEl = document.querySelector("h3.product-price");
        if(productPriceEl){
          let currentPriceEl = productPriceEl.querySelector(".cwc-oz44__current-price");
          if (currentPriceEl) {
            currentPriceEl.innerText = newPrice;
          } else {
            productPriceEl.innerText = newPrice;
          }

          let comparePrice = tBtn?.getAttribute("data-compare-price");
          let comparePriceEl = productPriceEl.querySelector(".cwc-oz44__compare-price");
          if (comparePriceEl) {
            if (comparePrice) {
              comparePriceEl.innerText = comparePrice;
              comparePriceEl.style.display = "inline";
            } else {
              comparePriceEl.style.display = "none";
            }
          }
        }

        // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", document.querySelector("h3.product-price").innerText , newPrice)

        let variantID = tBtn.getAttribute("data-variant-id");
        const variantSelect = document.querySelector(".main-product__variant-select");

        if (variantSelect) {
          variantSelect.value = variantID;
          variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // subButton = shadowRoot.querySelector(".skio-group-container.skio-group-container--subscribe");
      }
    });

    
    document.querySelector(".cwc-oz44__variant-selector-btn.__most-popular")?.click();
  }

  /* -----------------------------
     PRICE UPDATE FUNCTION
  ----------------------------- */
  function getUpdatedPrice() {
    const skioEl = document.querySelector("skio-plan-picker");
    if (!skioEl) return;

    const productAttr = skioEl.getAttribute("product");
    if (!productAttr) return;

    const productData = JSON.parse(productAttr);
    const variantInput = document.querySelector('form [name="id"]');
    if (!variantInput) return;

    const selectedVariantId = parseInt(variantInput.value);
    const variantData = productData.variants.find(v => v.id === selectedVariantId);
    if (!variantData) return;

    const oneTimePricePence = variantData.price;
    const oneTimePrice = (oneTimePricePence / 100).toFixed(2);

    const subscriptionAllocation = variantData.selling_plan_allocations?.[0];
    const subscriptionPricePence = subscriptionAllocation?.price;
    const subscriptionPrice = subscriptionPricePence
      ? (subscriptionPricePence / 100).toFixed(2)
      : null;

    let subscriptionDiscountPercent = 0;
    if (subscriptionPricePence && oneTimePricePence) {
      subscriptionDiscountPercent = (
        ((oneTimePricePence - subscriptionPricePence) / oneTimePricePence) * 100
      ).toFixed(0);
    }

    // DOM updates
    const otpPrice = document.querySelector(".cwc-oz44__subscription__one-time .cwc-oz44__subscription__heading-price > p");
    const otpComparePriceWrap = document.querySelector(".cwc-oz44__otp-compare-price-wrap");
    const otpComparePrice = document.querySelector(".cwc-oz44__otp-compare-price");
    const subSavePrice = document.querySelector(".cwc-oz44__subscription__heading-price__new-price p");
    const subSaveOldPrice = document.querySelector(".cwc-oz44__subscription__sub-save .cwc-oz44__subscription__heading-price__old p");
    const subSaveDiscount = document.querySelector(".cwc-oz44__subscription__heading-price__new-discount p");

    if (otpPrice) otpPrice.innerText = "£ " + oneTimePrice;

    // Compare price logic for OTP
    const compareAtPricePence = variantData.compare_at_price;
    if (compareAtPricePence && compareAtPricePence > oneTimePricePence) {
      const compareAtPrice = (compareAtPricePence / 100).toFixed(2);
      if (otpComparePrice) otpComparePrice.innerText = "£ " + compareAtPrice;
      
      if (otpComparePriceWrap) otpComparePriceWrap.style.display = "block";
    } else {
      if (otpComparePriceWrap) otpComparePriceWrap.style.display = "none";
    }

    if (subSavePrice) subSavePrice.innerText = "£ " + subscriptionPrice;
    if (subSaveOldPrice) subSaveOldPrice.innerText = "£ " + oneTimePrice;
    if (subSaveDiscount) subSaveDiscount.innerText = "-" + subscriptionDiscountPercent + "%";


    if (subscriptionPrice !== null) {
      document.body.classList.remove("__no-sub-and-save");
      if (!document.querySelector(".cwc-oz44__subscription__sub-save .cwc-oz44__subscription__radio.__selected")) {
        document.querySelector(".cwc-oz44__subscription__sub-save")?.click();
      }
    } else {
      document.body.classList.add("__no-sub-and-save");
      if (!document.querySelector(".cwc-oz44__subscription__one-time .cwc-oz44__subscription__radio.__selected")) {
        document.querySelector(".cwc-oz44__subscription__one-time")?.click();
      }
    }

    document.body.classList.remove("__cwc-initialising");
  }

  function waitForVariant() {
    const variantInput = document.querySelector('form [name="id"]');
    const skioEl = document.querySelector("skio-plan-picker");
    const productAttr = skioEl?.getAttribute("product");

    if (!variantInput || !productAttr) {
      setTimeout(waitForVariant, 200);
      return;
    }

    getUpdatedPrice();
  }

  waitForVariant();

  document.addEventListener("change", (e) => {
    if (e.target.name === "id") {
      getUpdatedPrice();
    }
  });

  function removeSelected() {
    document.querySelectorAll(".cwc-oz44__subscription__radio.__selected").forEach(radio => {
      radio.classList.remove("__selected");
    });
  }

  waitForElement(
  () => typeof window.addNewCross === "function",
  () => {
    
    if (typeof window.addNewCross === "function") {
        window.addNewCross();
      } else {
        // console.log("window.addNewCross(); is not a function");
      }
    });
  }
);
